import TypeToReducer from 'type-to-reducer';

import { normalize, schema } from 'normalizr';

import {
  GET_PROVIDERS,
  SET_PROVIDERS_PAGINATION,
  SET_PROVIDERS_FILTERS,
  RESET_PROVIDERS,
  TOGGLE_PROVIDER,
} from 'providers/constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const provider = new schema.Entity('providers');

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: ['key', 'name', 'mail', 'telephone', 'rfc'],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  entities: { providers: {} },
  result: { providers: [] },
};

export const getPending = (state) => ({
  ...state,
  isLoading: true,
  needFetch: false,
});
export const getFulfilled = (state, { payload }) => {
  const pagination = {
    ...state.pagination,
    limit: payload.limit,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  };

  const normalized = normalize({ providers: payload.records }, { providers: [provider] });

  return { ...state, isLoading: false, pagination, ...normalized };
};
export const getRejected = (state) => ({ ...state, isLoading: false });

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

export const togglePending = (state, { meta }) => ({
  ...state,
  entities: {
    ...state.entities,
    providers: {
      ...state.entities.providers,
      [meta.id]: { ...state.entities.providers[meta.id], isLoading: true },
    },
  },
});

export const toggleRejected = (state, { meta }) => ({
  ...state,
  entities: {
    ...state.entities,
    providers: {
      ...state.entities.providers,
      [meta.id]: { ...state.entities.providers[meta.id], isLoading: true },
    },
  },
});

export const toggleFulfilled = (state, { payload }) => ({
  ...state,
  entities: {
    ...state.entities,
    providers: {
      ...state.entities.providers,
      [payload.providerClient.id]: {
        ...payload.providerClient,
        isLoading: false,
      },
    },
  },
});

const providersListReducers = {
  [GET_PROVIDERS]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [SET_PROVIDERS_PAGINATION]: setPagination,
  [SET_PROVIDERS_FILTERS]: setFilters,
  [RESET_PROVIDERS]: reset,
  [TOGGLE_PROVIDER]: {
    [PENDING]: togglePending,
    [REJECTED]: toggleRejected,
    [FULFILLED]: toggleFulfilled,
  },
};

export default TypeToReducer(providersListReducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/reducers/providers_list_reducers.js